import { render, staticRenderFns } from "./wizardAssesmentReview.vue?vue&type=template&id=64e8c39c&scoped=true"
import script from "./wizardAssesmentReview.vue?vue&type=script&lang=js"
export * from "./wizardAssesmentReview.vue?vue&type=script&lang=js"
import style0 from "./wizardAssesmentReview.vue?vue&type=style&index=0&id=64e8c39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e8c39c",
  null
  
)

export default component.exports